export default __webpack_public_path__ + "497b4484b7335c1f0c119bd5b92a6bff.ttf";